/**
 * The session API answers in camelCase; the detail page, the external-links card
 * and the custom reports panel read snake_case. Map once, here.
 */
export function normalizeSession(session) {
  const transcriptLanguage = session.transcriptLanguage || session.transcript_language;
  return {
    ...session,
    user_id: session.userId || session.user_id,
    user_name: session.userName || session.user_name,
    user_email: session.userEmail || session.user_email,
    original_file_id: session.originalFileId || session.original_file_id,
    original_filename: session.originalFilename || session.original_filename,
    processing_started_at: session.processingStartedAt || session.processing_started_at,
    processing_completed_at: session.processingCompletedAt || session.processing_completed_at,
    error_message: session.errorMessage || session.error_message,
    event_id: session.eventId || session.event_id,
    event_title: session.eventTitle || session.event_title,
    event_wp_id: session.eventWpId || session.event_wp_id,
    event_faicon_id: session.eventFaiconId || session.event_faicon_id,
    wp_session_id: session.wpSessionId || session.wp_session_id,
    faicon_session_id: session.faiconSessionId || session.faicon_session_id,
    created_at: session.createdAt || session.created_at,
    updated_at: session.updatedAt || session.updated_at,
    has_reports: session.hasReports || session.has_reports || false,
    duration_seconds: session.durationSeconds || session.duration_seconds,
    transcript_status: session.transcriptStatus || session.transcript_status || session.status,
    transcript_processing_started_at: session.transcriptProcessingStartedAt || session.transcript_processing_started_at,
    transcript_processing_completed_at: session.transcriptProcessingCompletedAt || session.transcript_processing_completed_at,
    transcript_processing_duration: session.transcriptProcessingDuration || session.transcript_processing_duration,
    transcript_error_message: session.transcriptErrorMessage || session.transcript_error_message,
    transcript_provider: session.transcriptProvider || session.transcript_provider,
    transcript_language: transcriptLanguage,
    primary_language: session.primaryLanguage || session.primary_language || transcriptLanguage || 'en',
    transcript_chunks_total: session.transcriptChunksTotal || session.transcript_chunks_total,
    transcript_chunks_completed: session.transcriptChunksCompleted || session.transcript_chunks_completed,
    transcript_current_chunk: session.transcriptCurrentChunk || session.transcript_current_chunk,
    session_at_glance_md: session.sessionAtGlanceMd ?? session.session_at_glance_md ?? '',
    full_report_md: session.fullReportMd ?? session.full_report_md ?? '',
    speakers_md: session.speakersMd ?? session.speakers_md ?? '',
    in_depth_md: session.inDepthMd ?? session.in_depth_md ?? '',
    report_settings: session.reportSettings || session.report_settings || null,
  };
}
